import React from 'react';
import { useTranslation } from 'react-i18next';
import Header from '../../commons/Header';
import Footer from '../../commons/Footer';
import BurgerMenu from '../../commons/BurgerMenu';
import { ReactComponent as IconInvoices } from '../../images/icn_fatture.svg';
import {
  ContFlexLeft,
  ContFlexRight,
  BtnRadiusWhite,
  ContFilterYear,
  ContFilterCheckbox,
} from '../../styled-components';
import SearchInput from '../../commons/SearchInput';
import InvoiceCollapse from './InvoiceCollapse';
import NewInvoiceModal from '../../commons/NewInvoiceModal';
import { Row, Col, Button } from 'reactstrap';
import Label from 'reactstrap/lib/Label';
import FormGroup from 'reactstrap/lib/FormGroup';
import CustomInput from 'reactstrap/lib/CustomInput';
import Form from 'reactstrap/lib/Form';
import generateYearOptions from '../../lib/helpers/generateYearOptions';
import generateMonthOptions from '../../lib/helpers/generateMonthOptions';
import variables from '../../variables';
import InvoicesImportFeedbackModal from './InvoicesImportFeedbackModal';

function InvoicesPresentational({
  data = [],
  query,
  onFilter,
  searchAdministrators,
  searchEstateAgents,
  searchAssociations,
  searchCommercials,
  searchUtilizers,
  fetchAdminCondos,
  fetchAdminCustomers,
  fetchUtilizer,
  condos,
  customersExtra,
  utilizer,
  onNewInvoiceConfirm,
  onInvoiceUpdate,
  onAddPayment,
  onDeletePayment,
  onValidateInvoice,
  onInvoiceDelete,
  onImportInvoices,
  toggleShowImportFeedback,
  invoicesImportFeedbackData,
  hasImportedInvoices,
  profileType,
}) {
  const [t] = useTranslation('INVOICES');

  function handleImportFile(event) {
    const file = event.target?.files[0];

    const fileSize = (Number(file?.size || 0) / 1024 ** 2).toFixed(2);

    if (fileSize > 20) {
      alert.info('File troppo grande. Sono ammessi file di massimo 20MB');
    } else {
      const data = new FormData();
      data.append('file', file);
      onImportInvoices(data);
    }
  }

  return (
    <div className="App">
      <BurgerMenu />

      <div className="corpo">
        <InvoicesImportFeedbackModal
          data={invoicesImportFeedbackData}
          toggle={toggleShowImportFeedback}
          isOpen={hasImportedInvoices}
        />
        <section>
          <Header
            title={
              profileType === 'SUPPLIER'
                ? t('PAGES:INVOICES')
                : t('PAGES:CONSULTING')
            }
            icon={
              <IconInvoices fill={variables.white} style={{ height: '25px' }} />
            }
          />

          <Row>
            <Col xs={12} style={{ marginBottom: 30 }}>
              <Button
                href={`/examples/Template_Fatture.csv`}
                target="_blank"
                color="primary"
              >
                Scarica template importazione
              </Button>
              <Button
                href={`/documentation/Extra_Importazione_fatture.pdf`}
                target="_blank"
                color="primary"
                style={{ marginLeft: '2rem' }}
              >
                Scarica documentazione importazione
              </Button>
            </Col>
            <Col sm="12" md="4">
              <ContFlexLeft>
                <NewInvoiceModal
                  searchAdministrators={searchAdministrators}
                  searchEstateAgents={searchEstateAgents}
                  searchCommercials={searchCommercials}
                  searchAssociations={searchAssociations}
                  searchUtilizers={searchUtilizers}
                  fetchAdminCondos={fetchAdminCondos}
                  fetchAdminCustomers={fetchAdminCustomers}
                  fetchUtilizer={fetchUtilizer}
                  fetchedUtilizer={utilizer}
                  condos={condos}
                  customersExtra={customersExtra}
                  onConfirm={onNewInvoiceConfirm}
                />
              </ContFlexLeft>
            </Col>
            <Col sm="12" md="8">
              <ContFlexRight className="show-invoices">
                <BtnRadiusWhite
                  className={
                    query.all === 'false' ? 'eye-toggle show-me' : 'eye-toggle'
                  }
                  onClick={() =>
                    onFilter({ all: query.all === 'true' ? 'false' : 'true' })
                  }
                >
                  <i className="far fa-eye"></i>
                </BtnRadiusWhite>
              </ContFlexRight>
            </Col>
          </Row>
          <Form className="m-t-20">
            <Row className="compensi-variabili-resp">
              <Col lg="6" xl="3">
                <ContFilterYear className="no-width">
                  <Row>
                    <Col xs="6">
                      <Label>{t('CONTACTS:TITLE_FILTER_YEAR')}</Label>
                    </Col>
                    <Col xs="6">
                      <FormGroup>
                        <CustomInput
                          type="select"
                          id="selectYear"
                          name="year"
                          value={query && query.year}
                          onChange={({ target: { value: year } }) =>
                            onFilter({ year })
                          }
                        >
                          {generateYearOptions()}
                        </CustomInput>
                      </FormGroup>
                    </Col>
                  </Row>
                </ContFilterYear>
              </Col>
              <Col lg="6" xl="3">
                <SearchInput
                  query={{ search: query && query.number }}
                  onFilter={({ search }) => onFilter({ number: search })}
                  label={t('SEARCH:INVOICE_NUMBER')}
                />
              </Col>
              <Col lg="6" xl="3">
                <SearchInput
                  query={{ search: query && query.customer }}
                  onFilter={({ search }) => onFilter({ customer: search })}
                  label={t('SEARCH:CUSTOMER')}
                />
              </Col>
              <Col lg="6" xl="3">
                <SearchInput
                  query={{ search: query && query.admin }}
                  onFilter={({ search }) => onFilter({ admin: search })}
                  label={t('SEARCH:ADMINISTRATOR')}
                />
              </Col>
              <Col lg="6" xl="3">
                <ContFilterYear className="no-width">
                  <Row>
                    <Col xs="6">
                      <Label>{t('COMMON:TITLE_FILTER_ACC_YEAR')}</Label>
                    </Col>
                    <Col xs="6">
                      <FormGroup>
                        <CustomInput
                          type="select"
                          id="selectAccountabilityYear"
                          name="accountabilityYear"
                          className="year-select"
                          value={query && query.accountabilityYear}
                          onChange={({
                            target: { value: accountabilityYear },
                          }) => {
                            onFilter({ accountabilityYear });
                          }}
                        >
                          {generateYearOptions(true)}
                        </CustomInput>
                      </FormGroup>
                    </Col>
                  </Row>
                </ContFilterYear>
              </Col>
              <Col lg="6" xl="3">
                <ContFilterYear className="no-width">
                  <Row>
                    <Col xs="6">
                      <Label>{t('COMMON:TITLE_FILTER_ACC_MONTH')}</Label>
                    </Col>
                    <Col xs="6">
                      <FormGroup>
                        <CustomInput
                          type="select"
                          id="accountabilityMonth"
                          name="accountabilityMonth"
                          className="year-select"
                          disabled={!query.accountabilityYear}
                          value={
                            query && query.accountabilityMonth === null
                              ? ''
                              : query.accountabilityMonth
                          }
                          onChange={({
                            target: { value: accountabilityMonth },
                          }) => onFilter({ accountabilityMonth })}
                        >
                          {generateMonthOptions()}
                        </CustomInput>
                      </FormGroup>
                    </Col>
                  </Row>
                </ContFilterYear>
              </Col>
              <Col sm="6" md="6" lg="3" xl="3">
                <FormGroup>
                  <CustomInput
                    type="file"
                    id="importFilee"
                    name="importFilee"
                    onChange={(event) => handleImportFile(event)}
                    accept=".csv"
                  />
                  <Label for="selectFile">
                    {t('INVOICES:CHOOSE_FILE')}
                    &nbsp;({t('INVOICES:MAX_UPLOAD_FILE_SIZE')})
                  </Label>
                </FormGroup>
              </Col>
              <Col sm="12" md="12" lg="3" xl="3">
                <FormGroup>
                  <ContFilterCheckbox>
                    <CustomInput
                      type="checkbox"
                      id="toBill"
                      label="Fatture da retrocedere"
                      inline
                      checked={query && query.toBill === 'true'}
                      onChange={({ target: { checked } }) => {
                        onFilter({ toBill: checked ? 'true' : 'false' });
                      }}
                    />
                  </ContFilterCheckbox>
                </FormGroup>
              </Col>
            </Row>
          </Form>
        </section>

        <section>
          {data.map((invoice, index) => (
            <InvoiceCollapse
              key={index}
              invoice={invoice}
              searchAdministrators={searchAdministrators}
              searchEstateAgents={searchEstateAgents}
              searchCommercials={searchCommercials}
              searchUtilizers={searchUtilizers}
              onUpdate={onInvoiceUpdate}
              onAddPayment={onAddPayment}
              onDeletePayment={onDeletePayment}
              onValidateInvoice={onValidateInvoice}
              onInvoiceDelete={onInvoiceDelete}
            />
          ))}
        </section>
        <Footer />
      </div>
    </div>
  );
}

export default InvoicesPresentational;
